<template>
  <div class="CenteredTextBox">
    <HeadingChunk :heading="content.heading" :label="content.label" class="headingChunk" />
    <BodyChunk :body="content.body" :cta="content.cta" :ctas="content.ctas" v-bind="{ ctaOptions }" class="bodyChunk" />
  </div>
</template>

<script setup>
import BodyChunk from './BodyChunk.vue'
import HeadingChunk from './HeadingChunk.vue'

const { content } = defineProps({ content: Object })

const ctaOptions = { form: 'button', colorClass: '--bright-blue' }
</script>

<style scoped>

.headingChunk + .bodyChunk {
  margin-top: var(--spacing-7);
}

@media (--screen-lg) {

  .CenteredTextBox {
    text-align: center;
    margin: 0 auto;
    max-width: var(--centered-text-box-width, 850px);
  }

  .headingChunk {
    --heading-font-size: var(--font-size-9);
  }
}
</style>
